import React, { useState } from 'react'
import "../../styles/matchStatsRefereeCard.css";

export default function MatchStatsRefereeCard({ stats }) {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <div className='ms-referee-card'>

            <div className='ms-stat-referee-title' onClick={() => setIsOpen(!isOpen)}>
                Játékvezető statisztikák
            </div>



            {isOpen && (
                <div className="stat-card-border">
                    <div className='ms-referee-stat-list'>
                        {stats.referee.map(r => {
                            return (
                                <div className='ms-referee-stat-row'>
                                    <span className='ms-referee-label'>
                                        {r.label}
                                    </span>

                                    <span className='ms-referee-value'>
                                        {r.home_value}
                                    </span>

                                </div>

                            )
                        })}
                    </div>
                </div>
            )}


        </div>
    )
}
